import { classNames } from "../../../helpers/classNames";

export default function Container({ children, bgColor = 'bg-white' ,id}) {
    return (
        <div className={bgColor} id={id}>
            <div className={classNames("mx-auto max-w-screen-2xl relative z-0 px-5 sm:px-10 md:px-16 lg:px-20  xl:px-24 py-16  sm:py-24 lg:py-28 xl:py-36")}>
                {children}
            </div>
        </div>)
}
